module.exports = __webpack_public_path__ + "img/Spotify_Logo_RGB_Black.1f61ed6f.png";